import { lazy } from 'react';

import { PageContainer } from '@app/components/Reporting/components/PageContainer/PageContainer';
import { ReactWebComponent } from '@app/utils/web-components';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const UsageOverviewSwitch = lazy(() => import('./UsageOverviewSwitch'));

class UsageOverviewWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['teamUuid'];
    }

    render() {
        const teamUuid = this.prop('teamUuid');

        return (
            <RootProviders>
                <PageContainer>
                    <UsageOverviewSwitch teamUuid={teamUuid} />
                </PageContainer>
            </RootProviders>
        );
    }
}

customElements.define('usage-overview', UsageOverviewWebComponent);
